import Vue from 'vue';
import VueCookies from 'vue-cookies';

const domain = window.location.hostname;

Vue.use(VueCookies, {domain : `.${domain}`});

export default VueCookies;
